import { useList, useDetail, useCreate, useUpdate, fetchApi, useDelete } from "@inmagik/react-crud"
import { Biblioteca } from "../types"
import { API_URL } from "../constants"
import { useAuth } from "../auth"
import { useCallback } from "react"
import { normalizeParams } from "@inmagik/react-crud/dist/crud/utils"

export function useBibliotecheList(params: Record<string, string> = {}) {
  return useList<Biblioteca>(`${API_URL}/admin/biblioteche`, {
    query: params,
  })
}

export function useBiblioteca(id: number | undefined) {
  return useDetail<Biblioteca>(`${API_URL}/admin/biblioteche`, id?.toString())
}

export function useBibliotecaCreate() {
  return useCreate<Biblioteca>(`${API_URL}/admin/biblioteche`)
}

export function useBibliotecaUpdate() {
  return useUpdate<Biblioteca>(`${API_URL}/admin/biblioteche`)
}

export function useBibliotecaLazy() {
  const auth = useAuth()
  return useCallback((id: number) => {
    return fetchApi(`${API_URL}/admin/biblioteche/${id}`, {
      method: "GET",
      responseType: "json",
      headers: {
        Authorization: `Bearer ${auth.tokens?.access}`,
      },
    }) as Promise<Biblioteca>
  }, [])
}

export function useBibliotecheLazy() {
  const auth = useAuth()
  return useCallback((params: Record<string, string | number | Array<number>>) => {
    const qs = normalizeParams(params).toString()
    return fetchApi(`${API_URL}/admin/biblioteche?${qs}`, {
      method: "GET",
      responseType: "json",
      headers: {
        Authorization: `Bearer ${auth.tokens?.access}`,
      },
    }) as Promise<{ results: Biblioteca[] }>
  }, [])
}

export function useBibliotecaDelete() {
  return useDelete(`${API_URL}/admin/biblioteche`)
}

